<template>
    <footer class="footer">
        <div class="footer-primary container">
            <div class="wrapper">
                <section class="footer-section" v-if="shops.length != 0">
                    <h2 class="footer-section__title">Our shops</h2>
                    <ul class="footer-section__list">
                        <li v-for="(shop, index) in shops" :key="index">
                            <a :href="shop.url">Beautizon on {{ shop.title }}</a>
                        </li>
                    </ul>
                </section>
                <section class="footer-section">
                    <h2 class="footer-section__title">Contact us</h2>
                    <div v-if="contactDetails.phone">
                        <h3 class="contact-info__title" v-if="contactDetails.phone">Phone number</h3>
                        <a class="contact-info__detail" :href="'tel:'+contactDetails.phone" v-if="contactDetails.phone">{{ contactDetails.phone }}</a>
                    </div>
                    <div v-if="contactDetails.email">
                        <h3 class="contact-info__title" v-if="contactDetails.email">Email</h3>
                        <a class="contact-info__detail" :href="'mailto:'+contactDetails.email" v-if="contactDetails.email">{{ contactDetails.email }}</a>
                    </div>
                    <div v-if="contactDetails.workingHours">
                        <h3 class="contact-info__title" >Working hours</h3>
                        <div class="contact-info__detail">{{ contactDetails.workingHours }}
                    </div></div>
                </section>
                <section class="footer-section">
                    <h2 class="footer-section__title">Brands</h2>
                    <ul class="footer-section__list">
                        <li v-for="(brand, index) in brands" :key="index">
                            <a :href="brand.url">Brands | {{ brand.title }}</a>
                        </li>
                    </ul>
                </section>
                <section class="footer-section" v-if="socialLinks.facebook || socialLinks.twitter || socialLinks.instagram || socialLinks.youtube">
                    <h2 class="footer-section__title">Follow us</h2>
                    <!-- <div class="newsletter__text">Subscribe to get our latest news & updates</div>
                    <form action="">
                        <div class="input-btn footer-section__input-btn">
                            <input class="input-btn__text" type="email" name="" id="" placeholder="Enter your email address">
                            <input class="input-btn__submit" type="submit" value="Submit">
                        </div>
                    </form> -->
                    <ul class="social-list">
                        <li v-if="socialLinks.facebook">
                            <a :href="socialLinks.facebook">
                                <i class="fab fa-facebook"></i>
                            </a>
                        </li>
                        <li v-if="socialLinks.twitter">
                            <a :href="socialLinks.twitter">
                                <i class="fab fa-twitter"></i>
                            </a>
                        </li>
                        <li v-if="socialLinks.instagram">
                            <a :href="socialLinks.instagram">
                                <i class="fab fa-instagram"></i>
                            </a>
                        </li>
                        <li v-if="socialLinks.youtube">
                            <a :href="socialLinks.youtube">
                                <i class="fab fa-youtube"></i>
                            </a>
                        </li>
                    </ul>
                </section>
            </div>
        </div>
        <div class="footer-secondary container">Copyright © {{ (new Date()).getFullYear() }} Beautizon. All rights reserved. Made by <a href="http://xenia.tech/" class="white-link">Xenia Tech</a></div>
    </footer>
</template>

<script>
export default {
    props: ['socialLinks', 'shops', 'brands', 'contactDetails']
}
</script>

<style lang="scss">
@import "@/assets/css/helpers-variables.scss";
.footer {
  .wrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    margin: 0 auto;
  }
}
.footer-primary {
  background: #2a2c30;
  color: white;
  padding-top: 40px;
  padding-bottom: 40px;
  @media (min-width: $laptop-s) {
    padding-top: 80px;
  padding-bottom: 80px;
  }
}
.footer-section {
    // width: 100%;
    padding: 0 20px;
  &:not(:last-child) {
    margin-bottom: 40px;
  }
  @media (min-width: $tablet) {
    // width: 50%;
  }
  @media (min-width: $laptop-l) {
    // width: 25%;
  }
  @media (min-width: 811px) {
    margin-bottom: 0 !important;
  }
}
.footer-section__title {
  text-transform: uppercase;
  margin-bottom: 40px;
  font-size: 0.75em;
  letter-spacing: 1px;
}
.footer-section__list {
  font-size: 0.8em;
  li:not(:last-child) {
    margin-bottom: 1em;
    line-height: 1.3;
  }
}
.contact-info__title {
  opacity: 0.5;
  font-size: 0.75em;
}
.contact-info__detail {
  font-size: 0.8em;
  display: block;
  &:not(:last-child) {
    margin-bottom: 0.5em;
  }
}
.newsletter__text {
  font-size: 0.8em;
  margin-bottom: 1em;
}
.footer-section__input-btn {
  margin-bottom: 1.5em;
}
.social-list {
  li {
    display: inline-block;
    color: $slate-grey;
    margin-right: 1.5em;
  }
}
.footer-secondary {
  background: $dark-grey;
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.8em;
  text-align: center;
  padding-top: 1em;
  padding-bottom: 1em;
}
.white-link {
    color: white;
}
</style>

